export default {
  root: {
    marginTop: 0,
    marginBottom: 0,
  },
  primary: {
    color: 'inherit',
  },
};
